<template>
  <div class="flex h-full min-h-0 flex-col">
    <div
      v-if="showToolbar"
      class="flex h-[53px] shrink-0 items-center justify-between px-2"
    >
      <div class="flex items-center">
        <slot name="toolbar-start" />
      </div>
      <div class="flex items-center">
        <slot name="toolbar-end" />
      </div>
    </div>

    <DraftPreview
      :key="previewKey"
      :source="source"
      :wrap-plaintext="wrapPlaintext"
      :rewrite-static-to-prod="rewriteStaticToProd"
      :extensions="extensions"
      class="grow"
    />
  </div>
</template>

<script setup lang="ts">
import type { PreviewSource } from "@/lib/api/queries/preview/types";

import DraftPreview from "./DraftPreview.vue";
import type { PreviewExtension } from "./frame/extension";

defineProps<{
  source: PreviewSource;
  wrapPlaintext?: boolean;
  rewriteStaticToProd?: boolean;
  extensions?: readonly PreviewExtension[];
  // Remounts the preview when it changes — used to reset state on context swaps.
  previewKey?: string;
  showToolbar?: boolean;
}>();
</script>
